import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Contact from "../components/contact";
import Hero from "./components/hero";
import TriCards from "./components/triCards";
import BeforeAfter from "./components/beforeAfter";
import PageShell from "../components/pageShell"
import ZigZag from "./components/zigzag";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const WindowPage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Window Cleaning - Flyby Shine</title>
                        <meta name="description" content="Utilizing state-of-the-art drone technology or traditional methods, we offer safe, efficient, and thorough cleaning solutions." />
                        <meta name="keywords" content="Window Cleaning, Window cleaning services, commercial window cleaning, industrial window cleaning, hygienic window cleaning, expert window cleaning services, safe window cleaning, thorough window cleaning, professional window cleaning, reliable window cleaning, top-quality window cleaning, window cleaning services, window cleaning solutions, window cleaning experts" />
                        <meta property="og:image" content="/assets/window.png" />
                    </>
                )}
            </MetaTagHandler>

            <PageShell>
                <Hero
                    subTitle={'Commercial & Industrial'}
                    title={'Window Cleaning'}
                    description={`Utilizing state-of-the-art drone technology or traditional methods, we offer safe, efficient, and thorough cleaning solutions. `}
                    banner={{ image: '/assets/window.png', alt: 'Traditional window cleaning' }}
                    callToAction={
                        <ButtonGroup>
                            <ButtonGroup.Button to={'https://fc.flybyshine.tech/request-work'} text={'Request an Estimate'} />
                            <ButtonGroup.Button to={'/commercial-industrial'} text={'All Services'} />
                        </ButtonGroup>
                    }

                />
                <TriCards>
                    <TriCards.Card
                        title={'Reach High Areas Safely'}
                        heading={{ image: '/assets/upwardIcon.svg', alt: 'about' }}
                        description={'With our state-of-the-art drone technology, we offer safe, efficient, and thorough cleaning solutions for multi-story buildings.'}

                    />
                    <TriCards.Card
                        title={'FAA Licensed Pilots'}
                        heading={{ image: '/assets/checkmark.svg', alt: 'about' }}
                        description={'Our team of FAA-licensed pilots brings exceptional expertise and reliability, ensuring top safety and quality standards in every project.'}
                    />
                    <TriCards.Card
                        title={'Faster Cleanings'}
                        heading={{ image: '/assets/boltIcon.svg', alt: 'about' }}
                        description={'Drones can clean large surface areas much faster than traditional methods, reducing the cleaning time.'}
                    />
                </TriCards>
                <BeforeAfter
                    title={"Before And After"}
                    description={"Window cleaning is a breeze with our advanced drone technology. Our drones can reach high areas safely and efficiently, providing a thorough cleaning solution for multi-story buildings."}
                    subTitle={"Window Cleaning"}
                    additionalDetails={
                        <div className="core-list">
                            <ul>
                                <li><i className="material-icons">check_circle_outline</i>Efficient & Fast Cleaning</li>
                                <li><i className="material-icons">check_circle_outline</i>Safe: No more ladders or platforms</li>
                                <li><i className="material-icons">check_circle_outline</i>Reach Inaccessible Areas</li>
                            </ul>
                        </div>
                    }
                    images={[

                        {
                            firstImage: {
                                imageUrl: '/assets/commercialBefore.jpg',
                            },
                            secondImage: {
                                imageUrl: '/assets/commercialAfter.jpeg',
                            }
                        }

                    ]}

                />

                <ZigZag>
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/highwindow.png', alt: 'Cleaning a window thats high up' }}
                        title={'Tailored Cleaning Approach'}
                        heading={{ image: '/assets/shieldIcon.svg', alt: 'protecting your property icon' }}
                        description={'We understand that every building is unique, which is why we tailor our cleaning approach to suit your specific needs.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/brighter.png', alt: 'drone displayed' }}
                        title={'Brighter, Cleaner Windows'}
                        heading={{ image: '/assets/sparkles.svg', alt: 'flexibility about us icon' }}
                        description={'Our drone-assisted and traditional window cleaning services ensure that your windows are spotless and streak-free.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{
                            video: '/assets/videos/windowclean.mp4',
                            thumbnail: '/assets/videos/thumbnails/windowclean.png',

                        }}
                        title={'Advanced Drone Technology'}
                        heading={{ image: '/assets/water.svg', alt: 'water icon' }}
                        description={'Our advanced drone technology allows us to reach high areas safely and efficiently, providing a thorough cleaning solution for every window.'}
                    />

                </ZigZag>
                <Contact />
            </PageShell>
            <style>
                {
                    `
                    .zigzag {
                    margin-top: 150px
                    }
                    `
                }
            </style>

        </>
    )
}

export default WindowPage
